import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M8 12l0 .01","key":"svg-1"}],["path",{"d":"M12 12l0 .01","key":"svg-2"}],["path",{"d":"M16 12l0 .01","key":"svg-3"}]]

const IconDotsCircleHorizontal = createReactComponent('outline', 'dots-circle-horizontal', 'DotsCircleHorizontal', __iconNode);

export default IconDotsCircleHorizontal;